import { memoize, range } from 'lodash';
import { DAYS, HOURS, MINUTES } from 'src/lib/player/constants';

const K = 1000;
const lineStridesX = [
  0.1,
  0.2,
  0.5,
  1,
  2,
  5,
  10,
  20,
  50,
  100,
  200,
  500,
  1 * K,
  2 * K,
  5 * K,
  10 * K,
  20 * K,
  50 * K,
  100 * K,
  200 * K,
  500 * K,
  1000 * K,
  2000 * K,
  5000 * K,
  10000 * K,
];
const lineStridesY = [0.5, 1, 2, 5, 10, 20, 50, 100, 200, 500, 1000, 2000, 5000];
const lineStridesTime = [
  1 * MINUTES,
  5 * MINUTES,
  10 * MINUTES,
  15 * MINUTES,
  30 * MINUTES,
  1 * HOURS,
  3 * HOURS,
  6 * HOURS,
  12 * HOURS,
  1 * DAYS,
  2 * DAYS,
  5 * DAYS,
  7 * DAYS,
  30 * DAYS,
  365 * DAYS,
];

export const findGridLinesDistance = memoize(
  function findGridLinesDistance(minX: number, maxX: number, count = 10): Array<number> {
    return findGridLines(minX, maxX, count + 1, lineStridesX).filter((a) => a > 0 && a < maxX);
  },
  (...args) => JSON.stringify(args),
);
export const findGridLinesElevation = memoize(
  function findGridLinesElevation(minY: number, maxY: number, count = 5): Array<number> {
    return findGridLines(minY, maxY, count, lineStridesY).filter((a) => a > minY && a < maxY);
  },
  (...args) => JSON.stringify(args),
);
export const findGridLinesTime = memoize(
  function findGridLinesTime(minX: number, maxX: number, count = 10): Array<number> {
    return findGridLines(minX, maxX, count, lineStridesTime).filter((a) => a > minX && a < maxX);
  },
  (...args) => JSON.stringify(args),
);
export function findGridLines(
  min: number,
  max: number,
  count: number,
  lineStrides: Array<number>,
): Array<number> {
  let stride = lineStrides[0];
  for (const _stride of lineStrides) {
    if ((max - min) / _stride < count) {
      stride = _stride;
      break;
    }
  }
  const gridMin = Math.floor(min / stride) * stride;
  const gridMax = Math.ceil(max / stride) * stride;
  return range(gridMin, gridMax + 1, stride);
}
